<template>
	<div class="pe-form">
		<el-form :model="childConfigInfo" :rules="rules" v-loading="loading" ref="childConfigInfo" class="demo-ruleForm p-lr-20">
			<div class="c-333 f-s-14 m-b-15">质控价格：当前项目去重后总字数{{ childConfigInfo.wordsCount }}字/词（中朝或非中文单词）</div>
			<div v-show="childConfigInfoList.length > 0" v-for="(item,index) in childConfigInfoList" :key="index">
				<div class="d-f">
					<div class="c-333 f-s-14 f-w-600 min-w-100 p-r-10">
						<div v-if="item.taskType === 1">主质控任务</div>
						<div v-else>
							<span v-if="mainConfigInfoIndex > index || mainConfigInfoIndex == -1">质控子任务{{index+1}}</span>
							<span v-else>质控子任务{{index}}</span>
						</div>
						<el-tag v-if="item.status==1 || item.reciveStatus==1" class="m-t-5 m-l-7" type="danger">未领取</el-tag>
						<el-tag v-else class="m-t-5 m-l-7">已领取</el-tag>
					</div>
					<div class="f-s-14 c-666">
						<div class="m-b-5 d-f align-c">
							<span class="w-100">实际分配字数: </span>{{ item.wordNum }}字
							<span class="c-999 f-s-12 m-l-20">此字数为最终该质控任务字数</span>
						</div>
						<div class="m-b-5 d-f align-c">
							<span class="w-100">质控价格: </span>
							{{ item.priceType === 1 ? (childConfigInfo.status ===1 ? item.price : item.amount) : item.price }}
							{{ item.priceType === 1 ? '   元' : '   元/千字' }}
							<span class="m-l-10">（{{ item.priceType === 1 ? '一口价' : '单价' }}）</span>
						</div>
						<div class="m-b-5 d-f align-c" v-if="item.status==1 || item.status==3 || item.reciveStatus==1">
							<span class="w-100">{{ index === 0 ? '主' : '' }}质控人：</span>
							{{ item.newQcList.map(it => it.realname).toString().replace(',', ' ') }}
						</div>
						<div v-if="item.receiver" class="d-f align-c m-b-5">
							<span class="w-100">领取人：</span>{{ item.receiver }}
						</div>
						<div v-if="configInfo.status != 1" class="d-f align-c m-b-5">
							<span class="w-100">要求完成时间：</span>{{ childConfigInfo.limitTime | parseTime }}
						</div>
						<div v-if="configInfo.status != 1 && item.reciveStatus!=1" class="d-f align-c">
							<span class="w-100">派发时间：</span>{{ item.createTime | parseTime }}
						</div>
					</div>
				</div>
				<el-divider></el-divider>
			</div>
			<div v-show="childConfigInfo.wordsCount-compWords>0">
				<el-form-item prop="wordNum">
					<section class="d-f m-b-0">
						<div class="c-333 f-s-14 f-w-600 min-w-100 p-r-10">
							{{mainConfigInfoIndex== -1?'主质控任务':'质控子任务'}}
						</div>
						<section class="c-666">
							<div class="d-f align-c m-b-5">
								<span class="w-100">分配字数:</span>
								<el-input-number el-input-number :controls="false" :precision="0" :min="0"
									placeholder="请输入分配字数" v-model.number="childConfigInfo.wordNum"
								/>
								<p class="p-l-5 c-999 f-s-12">此字数为预计字数,实际确认字数会不小于分配字数,以确定后字数为准</p>
							</div>
							<div class="d-f align-c m-b-5">
								<span class="w-100">质控价格：</span>
								<el-radio-group v-model="childConfigInfo.priceType" prop="priceType">
									<el-radio :label="1">一口价</el-radio>
									<el-radio :label="2">字数*千字单价</el-radio>
								</el-radio-group>
							</div>
							<div class="d-f align-c m-b-10 p-l-100">
								<el-input-number :controls="false" v-model="childConfigInfo.price" :precision="2" :min="0" placeholder="请输入质控价格"/>
								<span class="input-company" v-if="childConfigInfo.priceType===2">元/千字</span>
								<span class="input-company" v-if="childConfigInfo.priceType===1">元</span>
								<span class="m-l-20" v-if="childConfigInfo.price && childConfigInfo.priceType === 2 && childConfigInfo.wordNum">
									共￥{{ (childConfigInfo.price * childConfigInfo.wordNum / 1000).toFixed(2) }}
								</span>
								<p class="f-s-12 c-999 m-l-10">建议价格：{{ recommendPrice }}元/千字</p>
							</div>
							<div class="d-f align-c m-b-10">
								<span class="w-100">选择质控人：</span>
								<div class="d-f align-c">
									<el-button type="primary" @click.stop="showZktr()">选择质控人</el-button>
									<span class="m-l-10 f-s-12 c-999 f-w-600">（质控一次可推送多人，一个人领取后其他人则无法看到此任务）</span>
								</div>
							</div>
							<div class="p-l-100 m-b-5">
								<ul class="ul-zkr">
									<li v-for="(item,index) in childConfigInfo.qcList" :key="index">
										<span>{{ item.realname }}</span>
									</li>
									<li v-for="(item,index) in newQcList" :key="index">
										<span>{{ item.realname }}</span>
										<i class="el-icon-close" @click.stop="delZkr(item,index)"/>
									</li>
								</ul>
							</div>
							<div class="p-l-100" v-if="newQcList && newQcList.length">
								<el-button type="primary" :disabled="allocation" @click="allocationConfirm()">
									分配确定
								</el-button>
							</div>
						</section>
					</section>
				</el-form-item>
			</div>
			<div v-show="childConfigInfo.wordsCount-compWords>0">
				<el-divider></el-divider>
			</div>
			<el-form-item v-if="isShowReset && childConfigInfo.status == 1" label="任务截止时间" prop="limitTime">
				<el-date-picker
					v-model="childConfigInfo.limitTime"
					:disabled="childConfigInfo.status === 2"
					type="datetime"
					@input="handleTiem"
					format='yyyy-MM-dd HH:mm'
					valueFormat='timestamp'
					:pickerOptions="this.pickerOptions"
					placeholder="选择任务截止时间">
				</el-date-picker>
				<p class="p-l-100 c-999 f-s-12">截止时间不能小于PE结束时间</p>
			</el-form-item>
			<el-form-item v-if="configInfo.status === 1" class="p-l-100">
				<el-button size="medium" type="primary" class="min-w-160"
					v-if="childConfigInfo.isQcCanChoose && permissions.dot_flow_start"
					:disabled="childConfigInfo.wordsCount-compWords>0 || !childConfigInfo.limitTime"
					@click.stop="submitForm('childConfigInfo')">确定
				</el-button>
				<el-button size="medium" type="primary" class="min-w-160"
					v-if="childConfigInfo.isQcCanChoose  && permissions.dot_flow_start"
					:disabled="childConfigInfoList.length===0"
					@click="resetForm('childConfigInfo')">重置
				</el-button>
			</el-form-item>
			<!-- 有未领取的订单可以重置进行重新派发 -->
			<el-form-item v-show="receiveFlag && childConfigInfo.status != 1" class="p-l-100">
				<el-button size="medium" type="primary" class="min-w-160" @click="toPayout">重新派发</el-button>
			</el-form-item>
			<el-form-item v-show="!isShowReset" class="p-l-100">
				<el-button size="medium" type="primary" :disabled="childConfigInfo.wordsCount-compWords>0" class="min-w-160" @click="confirmConfig">确认配置</el-button>
				<el-button size="medium" class="min-w-160" @click="getQcList">取消</el-button>
			</el-form-item>
		</el-form>

		<!-- 选择邀请人弹窗 -->
		<el-dialog title="选择邀请人" :visible.sync="dialogZktr" :before-close="handleClose" width="55%">
			<avue-crud :option="qcOption" :data="childQcData" :search.sync="search" @search-change="searchChange" ref="crud">
				<template slot-scope="{row,index}" slot="search">
					<section class="d-f">
						<span class="p-t-5">资源类型：</span>
						<div class="w-90">
							<el-select v-model="search.resource" clearable placeholder="请选择">
								<el-option
									v-for="item in search.options"
									:key="item.value"
									:label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</div>
						
					</section>
					<div class="el-form-item el-form-item--small l-h-32 m-l-10">
						<el-checkbox v-model="search.isProceed">未被占用<span class="f-s-12">（无进行中任务</span>）</el-checkbox>
					</div>
				</template>
				<template slot="isProceed" slot-scope="scope">
					<span v-if="scope.row.isProceed===1">是</span>
					<span v-if="scope.row.isProceed===0">否</span>
				</template>
				<template slot-scope="{row,index}" slot="menu">
					<el-button type="primary" size="mini" @click.stop="addTr(row,index)">添加</el-button>
				</template>
			</avue-crud>
		</el-dialog>

	</div>
</template>

<script>

import {
	listQC,
	updateQcTask,
	configQcTaskByQc,
	configQcTaskByPm,
	checkWordNumByPm,
	checkWordNumByQc, 
	qcConfigInfo,
	assignQcInfo,
	reSetQcConfigByPm,
	reSetQcConfigByQc,
} from '@/api/dot/qc';
import {recommend} from '@/api/dot/order'
import {statistics} from '@/api/dot/flow'
import {mapGetters} from "vuex";
import {alertErroMsg, alertSuccessMsg, alertCommon} from "@/util/commonMsg";

export default {
  	props: ['configInfo', 'slan', 'tlan', 'staParams'],
	data() {
		var checkAllocateWordsCount = (rule, value, callback) => {
			if (!value) {
				this.$message.error('分配字数不能为空')
				return
			}
			setTimeout(() => {
				if (!Number.isInteger(value)) {
					callback(new Error('请输入分配字数'));
				} else {
					let newVar = this.childConfigInfo.wordNum + this.compWords;
					if ((this.childConfigInfo.wordsCount - this.compWords >= 1000 || 
						newVar < this.childConfigInfo.wordsCount) && 
						this.childConfigInfo.wordNum < 1000
					) {
					} else if (newVar > this.childConfigInfo.wordsCount) {
						this.$message.error('累计分配字数不得大于总字数')
					} else {
						callback();
					}
				}
			}, 50);
		};
		// 判断是pm还是qc
		var pmOrQc = () => {
			let type = this.$route.query.type;
			if(type == 'pm') {
				return true;
			} else if(type == 'qc') {
				return false;
			}
		};
		return {
			sort: null,// 上一个任务的最后包序号
			hasLoad: false,
			loading: false,
			childConfigInfo: this.configInfo,
			recommendPrice: {},
			childConfigInfoList: [],
			pmOrQc: pmOrQc(),
			rules: {
				price: [
					{required: true, message: '请输入价格', trigger: 'blur'}
				],
				limitTime: [
					{required: true, message: '请选择截止时间', trigger: 'blur'}
				],
				wordNum: [
					{validator: checkAllocateWordsCount, trigger: 'blur'}
				],
			},
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() < Date.now() - 8.64e7;
				},
			},
			qcData: [],
			qcOption: {
				filterBtn: true,
				card: true,
				emptyBtn: false,
				refreshBtn: false,
				header: false, //表格头部中间菜单
				page: false,
				menu: true,
				addBtn: false, //新增按钮
				columnBtn: false,
				delBtn: false,
				editBtn: false,
				searchSpan: 7,
				searchMenuSpan: 4,
				menuWidth: 100,
				column: [
					{
						label: "质控人",
						prop: 'realname',
						search: true,
						searchLabelWidth: 60
					},
					{
						label: "是否有进行中轻任务",
						prop: "isProceed",
					},
					{
						label: "资源类型",
						prop: "userType",
					},
					{
						label: '拉黑译员人数',
						prop: 'disabledTrCount'
					}
				]
			},
			childQcData: [],
			search: {
				resource:'',
				options: [
					{
						value: '兼职',
						label: '兼职'
					}, 
					{
						value: '全职',
						label: '全职'
					}, 
					{
						value: '团队',
						label: '团队'
					}, 
					{
						value: '公司',
						label: '公司'
					}
				],
			},
			newQcList: [],
			dialogZktr: false,
			qcPriceChangeFlag: false,
			isShowReset: true,
		};
	},
	watch: {
		childConfigInfoList: {
			handler(n, o) {
				if (n.length > 0) {
					this.childConfigInfo.wordNum = this.childConfigInfo.wordsCount - this.compWords;
				}
			},
			deep: true
		}
	},
	
	computed: {
		...mapGetters(['permissions', 'userInfo', 'roles']),
		allocation() {
			return !this.childConfigInfo.wordNum
				|| !this.childConfigInfo.priceType || !this.childConfigInfo.price || this.qcPriceChangeFlag
				|| this.newQcList.length === 0;
		},
		compWords() {
			return this.childConfigInfoList.length > 0 ? this.childConfigInfoList.map(item => item.wordNum).reduce((a, b) => {
				return parseInt(a) + parseInt(b)
			}, 0) : 0;
		},
		receiveFlag() {//判断是否显示‘重新派发’按钮
			if(this.roles.indexOf(13) > -1) {
				return this.childConfigInfoList.some(item => {
					return item.status == 1 && item.pid != null
				})
			} else {
				return this.childConfigInfoList.some(item => {
					return item.status == 1 && item.pid == null
				})
			}
		},
		mainConfigInfoIndex() {
			for(let i = 0; i < this.childConfigInfoList.length; i++) {
				if(this.childConfigInfoList[i].taskType == 1) {
					return i
				}
			}
			return -1;
		},
	},
	
	mounted() {
		this.getRecommend();
		this.getQcList();
	},
	methods: {
		// 获取建议价格
		getRecommend() {
			recommend(this.$route.query.orderId, 3).then(res => {
				this.recommendPrice = res.data.data
			})
		},

		// 获取质控任务列表
		getQcList() {
			this.isShowReset = true;
			this.sort = null;
			qcConfigInfo({orderId: this.$route.query.orderId, qcOrPm: ''}).then(resp => {
				this.childConfigInfoList = resp.data.data;
				this.childConfigInfoList.map(it => {
					it.qcPriceChangeFlag = true;
					it.newQcList = it.userWebVos;
					it.userWebVos = [];
				});
			});
		},

		// 获取重新分配数据
		getAssignList() {
			assignQcInfo({
				orderId: this.$route.query.orderId
			}).then(res=>{
				this.childConfigInfoList = null;
				this.childConfigInfoList = res.data.data.list;
				this.childConfigInfo.wordNum = this.childConfigInfo.wordsCount - this.compWords;
				this.isShowReset = false; //隐藏时间设置
			})
		},

		//点击重新派发
		toPayout() {
			this.getAssignList();
			statistics(Object.assign({
				event_name: '重新派发',
				event_type: 'click',
				class_name: 'assignQcInfo',
				class_url: '/dotadmin/dotadmin/qc/assignQcInfo',
				event_params: '{orderId: this.$route.query.orderId}'
			}, this.staParams))
		},

		// 分配确认
		allocationConfirm() {
			let wordNum = this.childConfigInfo.wordNum;
			let newVar = this.childConfigInfo.wordNum + this.compWords;
			if (newVar > this.childConfigInfo.wordsCount) {
				this.$message.error("累计分配字数不得大于总字数");
				return;
			}
			let price = this.$refs['childConfigInfo'].model.price;
			if (this.$refs['childConfigInfo'].model.priceType === 2) {
				price = (this.$refs['childConfigInfo'].model.price / 1000) * (this.childConfigInfo.wordsCount < 1
					? 1 : this.childConfigInfo.wordsCount)
			}
			let priceFlag = false;
			if (price < 3) {
				this.$alert('您填写的价格远低于平台平均价格，确定提交？', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					showCancelButton: true,
					callback: action => {
						if(action === 'confirm') {
							this.$refs['childConfigInfo'].model.newQcList = this.newQcList;
							let limitTime = this.$refs['childConfigInfo'].model.limitTime
							this.childConfigInfoList.push(JSON.parse(JSON.stringify(this.$refs['childConfigInfo'].model)));
							this.$refs['childConfigInfo'].resetFields();
							this.$refs['childConfigInfo'].model.limitTime = limitTime;
							this.newQcList = [];
							priceFlag = true;
							if (this.pmOrQc) {
								this.checkWordNumByPm({
									orderId: this.$route.query.orderId,
									sort: this.sort,
									word: wordNum
								})
							} else {
								this.checkWordNumByQc({
									orderId: this.$route.query.orderId,
									sort: this.sort,
									word: wordNum
								})
							}
						}
					},
				});
			} else {
				priceFlag = true;
				let hasMainTask = this.childConfigInfoList.some(item=>{
					return item.taskType == 1
				})
				this.$refs['childConfigInfo'].model.taskType = hasMainTask ? '2' : '1';
				this.$refs['childConfigInfo'].model.newQcList = this.newQcList;
				this.$refs['childConfigInfo'].model.reciveStatus = 1;
				this.$refs['childConfigInfo'].model.amount = this.childConfigInfo.priceType==1?this.$refs['childConfigInfo'].model.price:'';
				let limitTime = this.$refs['childConfigInfo'].model.limitTime;
				this.childConfigInfoList.push(JSON.parse(JSON.stringify(this.$refs['childConfigInfo'].model)));
				this.childConfigInfo.priceType = '';
				this.childConfigInfo.price = '';
				this.$refs['childConfigInfo'].model.limitTime = limitTime;
				this.newQcList = [];
			}
			if (!priceFlag) {
				return;
			}
			if (this.pmOrQc) {
				this.checkWordNumByPm({
					orderId: this.$route.query.orderId,
					sort: this.sort,
					word: wordNum
				})
			} else {
				this.checkWordNumByQc({
					qcTaskId: this.childConfigInfoList[0].taskId,
					sort: this.sort,
					word: wordNum
				})
			}
		},

		// checkWordNumByPm
		checkWordNumByPm(obj) {
			checkWordNumByPm(obj).then(res => {
				let result = res.data.data;
				this.childConfigInfoList[this.childConfigInfoList.length - 1].wordNum = parseInt(result.wordCount);
				this.childConfigInfoList[this.childConfigInfoList.length - 1].startSort = result.startSort;
				this.childConfigInfoList[this.childConfigInfoList.length - 1].endSort = result.endSort;
				this.childConfigInfoList[this.childConfigInfoList.length - 1].taskType = (result.startSort=== 1 ? 1 : 2);// 类型：1主任务 2子任务
				this.sort = result.endSort;
			});
		},

		// checkWordNumByQc
		checkWordNumByQc(obj) {
			checkWordNumByQc(obj).then(res => {
				let result = res.data.data;
				this.childConfigInfoList[this.childConfigInfoList.length - 1].wordNum = parseInt(result.wordCount);
				this.childConfigInfoList[this.childConfigInfoList.length - 1].startSort = result.startSort;
				this.childConfigInfoList[this.childConfigInfoList.length - 1].endSort = result.endSort;
				this.childConfigInfoList[this.childConfigInfoList.length - 1].taskType = (result.startSort=== 1 ? 1 : 2);// 类型：1主任务 2子任务
				this.sort = result.endSort;
			});
		},

		// 确认配置
		confirmConfig() {
			let paramArr = [];
			let params = this.childConfigInfoList.filter(item => {
				if(item.reciveStatus == 1) {
					return item
				};
			});
			params.map(item=>{
				let qcIds = item.newQcList.map(it=>{
					return it.staffId
				})
				paramArr.push({
					'qcIds': qcIds,
					'amount':  item.price,
					'priceType': item.priceType,
					'endSort': item.endSort,
					'taskType': item.taskType,
					'startSort': item.startSort,
					'wordNum': item.wordNum,
					'price': item.price
				})
			})
			if (this.pmOrQc) {
				reSetQcConfigByPm({
					list: paramArr,
					orderId: this.configInfo.orderId
				}).then(res=>{
					this.$message.success('配置成功');
					this.getQcList();
				}).catch(()=>{
					this.getQcList();
				})
			} else {
				reSetQcConfigByQc({
					list: paramArr,
					orderId: this.configInfo.orderId,
					qcTaskId: this.childConfigInfoList[0].taskId
				}).then(res=>{
					this.$message.success('配置成功');
					this.getQcList();
				}).catch(()=>{
					this.getQcList();
				})
			}
		},

		handleTiem(val) {
			this.$forceUpdate()    //需要使用强制更新
			this.childConfigInfo.limitTime = val //赋值
		},

		startQc(formName) {
			if (this.childConfigInfo.status === 1 && this.$refs[formName].model.limitTime < Date.now()) {
				this.$message.error("不可选择过去时间")
				this.loading = false
				return;
			}
			let peEndTime = this.childConfigInfo.peEndTime ? parseInt(this.childConfigInfo.peEndTime) : 0;
			if ((this.childConfigInfo.status === 1 || this.childConfigInfo.status === 2)
				&& this.$refs[formName].model.limitTime < peEndTime) {
				this.$message.error("不可选择小于PE结束时间")
				this.loading = false
				return;
			}
			let tempAmount = 0;
			this.childConfigInfoList.forEach(it => {
				if (it.priceType === 2) {
					it.amount = it.price * it.wordNum / 1000
				} else {
					it.amount = it.price
				}
			})
			tempAmount = this.childConfigInfoList.reduce((fr, lt) => {
				return lt.amount + fr
			}, 0)
			if (this.childConfigInfo.status === 2 && tempAmount > this.childConfigInfo.amount) {
				this.$message.error("你分配的质控金额大于该项目质控总金额")
				this.loading = false
				return;
			}
			let qcIds = [];
			this.newQcList.forEach(ele => {
				qcIds.push(ele.staffId);
			})
			let oldQcIds = []
			this.childConfigInfo.qcList.forEach(it => {
				oldQcIds.push(it.staffId)
			})
			this.childConfigInfoList.forEach(it => {
				it.qcIds = it.newQcList.map(item => item.staffId);
			})
			// 待配置
			if (this.childConfigInfo.status === 1) {
				if (this.childConfigInfoList.length === 0) {
					this.childConfigInfoList.push(JSON.parse(JSON.stringify(this.$refs['childConfigInfo'].model)))
					this.childConfigInfoList[0].qcIds = qcIds;
					if (this.childConfigInfoList[0].priceType === 1) {
						let price = this.childConfigInfoList[0].price;
						this.childConfigInfoList[0].amount = price;
						this.childConfigInfoList[0].price = null;
					} else {
						this.childConfigInfoList[0].amount = (this.childConfigInfoList[0].price
						* this.childConfigInfoList[0].wordNum / 1000).toFixed(2);
					}
				}
				this.childConfigInfoList.map(it => {
					if (it.priceType === 1) {
						it.price = null;
					}
				})
				let flowInfo = {
					dot: this.childConfigInfoList,
					limitTime: this.$refs[formName].model.limitTime,
					orderId: this.childConfigInfo.orderId,
				};
				if (this.pmOrQc) {
					configQcTaskByPm(flowInfo).then(response => {
						alertCommon(response.data.data)
					})
				} else {
					configQcTaskByQc(flowInfo).then(response => {
						alertCommon(response.data.data)
					})
				}
				// 待领取
			} else if (this.childConfigInfo.status === 2) {
				updateQcTask({
					qcConfigDtoList: this.childConfigInfoList,
					limitTime: this.$refs[formName].model.limitTime,
					orderId: this.$route.query.orderId,
				}).then(response => {
					if (response.data.data > 0) {
						alertSuccessMsg("保存成功")
					} else if (response.data.data === -1) {
						alertErroMsg("保存失败，质控任务已被领取")
					} else {
						alertErroMsg("保存失败")
					}
				})
			}
		},

		submitForm(formName) {
			this.startQc(formName);
			statistics(Object.assign({
				event_name: '确定',
				event_type: 'click',
				class_name: 'configQcTaskByPm',
				class_url: '/dotadmin/dotadmin/qc/configQcTaskByPm',
				event_params: '{dot: this.childConfigInfoList, limitTime: this.$refs[formName].model.limitTime, orderId: this.childConfigInfo.orderId}'
			}, this.staParams))
		},

		resetForm(formName) {
			this.$alert(`你即将重置该质控任务配置`, {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				showCancelButton: true,
				callback: action => {
					if (action === 'confirm') {
						let limitTime = this.$refs['childConfigInfo'].model.limitTime
						this.$refs[formName].resetFields();
						this.$refs[formName].model.limitTime = limitTime;
						this.childConfigInfoList = [];
						this.newQcList = [];
						this.sort = null;
					} else {
					}
				},
			});
		},

		//弹窗
		showZktr() {
			listQC({
				slan: this.slan,
				tlan: this.tlan
			}).then(res => {
				this.qcData = res.data.data
				this.childQcData = this.qcData
				this.dialogZktr = true
			})
		},

		handleClose() {
			this.dialogZktr = false
		},

		searchChange(params, done) {
			done();
			this.childQcData = this.qcData
			let temp = [];
			if (!params) {
				this.childQcData = this.qcData
			} else {
				this.childQcData.forEach(ele => {
				if (params.realname && params.realname !== ele.realname) {
					return
				}
				if (params.resource && params.resource !== ele.userType) {
					return
				}
				if (params.isProceed && ele.isProceed === 1) {
					return
				}
				temp.push(ele)
				})
			}
			this.childQcData = temp
		},

		addTr(row, index) {
			if (this.newQcList == null) {
				this.newQcList = []
			}
			if (this.childConfigInfo.qcList == null) {
				this.childConfigInfo.qcList = []
			}
			let temp = []
			temp = temp.concat(this.newQcList).concat(this.childConfigInfo.qcList);
			if (!temp.find(item => item.staffId === row.staffId)) {
				this.newQcList.push(row)
				this.$message.success(row.realname + "，添加成功")
			} else {
				this.$message.error(row.realname + "，已添加该质控人")
			}
		},

		delZkr(item, index) {
			this.newQcList.splice(index, 1)
		}
	},
}

</script>

<style lang="scss" scoped>
.input-note {
  margin: 0;
}

ul.ul-zkr {
  padding: 0;

  > li {
    width: auto;
    height: 30px;
    display: inline-block;
    list-style: none;
    line-height: 30px;
    background: #b3d8ff;
    color: #FFFFFF;
    text-align: center;
    margin-right: 10px;
    border-radius: 3px;

    > span {
      padding: 0 10px;
    }

    > .el-icon-close {
      margin-right: 3px;
      cursor: pointer;
    }
  }
}

.el-dialog__wrapper {
  :deep(.avue-group--card:last-child) {
    margin-bottom: 0 !important;
  }
}

.el-row {
  min-height: 36px;

  &:last-child {
    margin-bottom: 0;
  }
}

.common-content {
  font-size: 14px;
}

.grid-content {
  font-size: 14px;
  font-weight: bold;
  font-family: "Microsoft YaHei", sans-serif;
}

.bg-purple {
  font-size: 12px;
  color: lightgray;
}
</style>

